module.exports = __webpack_public_path__ + "static/media/gameof.20d97082.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/gameof.JPG
// module id = 490
// module chunks = 0